var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApps = function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-1 5.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm9 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  })));
};
export default SvgApps;